import { storage } from '@doxyme/ui/utils';
import { parseUserMetadata, useAuth } from '../useAuth';
import { StorageKeys } from '../../shared/constants';

/**
 * If userId is undefined, it returns an empty string.
 */
export const useGetUserId = (): string => {
  const { user } = useAuth();
  // Once all users are using Frontegg `userIdFromStorage` should be removed.
  const userIdFromStorage =
    storage.findItem(StorageKeys.CurrentUserId) === undefined
      ? ''
      : `${storage.findItem(StorageKeys.CurrentUserId)}`;
  const { legacyUserId = '' } = parseUserMetadata(user?.metadata);

  return legacyUserId?.toString() || userIdFromStorage;
};
